import React, { useCallback, useEffect, useState } from "react";
import _isNil from "lodash/isNil";
import { getWidth } from "../../../utils/relativeSizes";
import IEventProcessor from "../../../pages/GamePlay/eventProcessor/IEventProcessor";
import KukariMoveAnimation from "./KukariMoveAnimation";
import kukariIcon from "../../../assets/blue-token-icon.svg";
import { calculateCoordinates, checkIsLongStep } from "../utils";
import clsx from "clsx";
import styles from "./styles.module.css";
import { useSelector } from "react-redux";
import { getMovingKukari, getShouldShowScoreAnimation, getTokenPosition } from "../../../store/selectors/ludoboardSelectors";
import { PLAYER_NUMBER } from "../../../pages/GamePlay/types";
import { getBoardType } from "../store/actions";
import { setKukariMoveConfig } from "../../../store/actions/ludoboardActions";
import { BOARD_CONFIG, SOUND_KEYS } from "../constant";
import { getEventProcessor } from "../../../pages/GamePlay/eventProcessor";
import { playSound } from "../../../classes/sound";

// import { playSound } from 'classes/sound'
// import { DeviceEventEmitter } from "react-native";

// let processorInstance: IEventProcessor | null | undefined;
// export function getEventProcessor() {
//   if (_isNil(processorInstance)) {
//     // logger(TAG_NAMES.LS_GAMEPLAY, 'Unable to process events as processor do not exist')
//     return;
//   }
//   return processorInstance;
// }

function MovingKukari() {
  
  // const staticData = {
    //   finalPosition: 52,
    //   tokenIndex: 2,
    //   playerNumber: 1,
    //   initialPosition: 0,
    //   shouldShowScoreAnimation: true,
    // };
    
    // const {
      //   finalPosition,
      //   initialPosition,
      //   playerNumber,
      //   shouldShowScoreAnimation,
      // } = staticData;
      
  const { finalPosition, tokenIndex, playerNumber = PLAYER_NUMBER.ONE } = useSelector(getMovingKukari) || {}
  const initialPosition = useSelector(getTokenPosition.bind(null, null, playerNumber, tokenIndex))
  const boardType = useSelector(getBoardType)
  const shouldShowScoreAnimation = useSelector(getShouldShowScoreAnimation.bind(null, playerNumber))
  const [moveInfo, setMoveInfo] = useState<{currentPosition: number, nextPosition: number} | null>(
    initialPosition !== null ? {
      currentPosition: initialPosition,
      nextPosition: initialPosition + 1,
    } : null
  );
  const [opacity, setOpacity] = useState<number>(1);

  useEffect(() => {
    if (_isNil(finalPosition) || _isNil(initialPosition) || initialPosition >= finalPosition) {
      setMoveInfo(null);
      return;
    }
    if (_isNil(moveInfo)) {
      setOpacity(1);
      setMoveInfo({
        currentPosition: initialPosition,
        nextPosition: initialPosition + 1,
      });
    }
  }, [finalPosition, initialPosition, moveInfo]);

  const moveKukari = useCallback(() => {
    if (_isNil(finalPosition) || _isNil(initialPosition) || initialPosition > finalPosition) {
      return;
    }

    playSound(SOUND_KEYS.TOKEN_MOVE)
    // DeviceEventEmitter.emit('incrementScore')

    shouldShowScoreAnimation &&
      setKukariMoveConfig({ playerNumber, initialPosition, finalPosition, currentPosition: moveInfo?.nextPosition ?? 0 })

    if (moveInfo?.nextPosition === finalPosition) {
      setTimeout(() => {
        setOpacity(0);
      }, 20);
      getEventProcessor()?.finishMoveUserToken(initialPosition);
    } else {
      setMoveInfo((prevState) => {
        if (prevState) {
          return {
            currentPosition: prevState.nextPosition,
            nextPosition: prevState.nextPosition + 1,
          };
        } else {
          return prevState;
        }
      });
    }
  }, [moveInfo]);

  if (_isNil(moveInfo) || _isNil(finalPosition)) {
    return null;
  }

  // console.log("<><><> moveInfo", moveInfo);

  return (
    <div className={clsx(styles.kukariMainContainer)} style={{
      width: getWidth(0),
      height: getWidth(0)
    }}>
    <KukariMoveAnimation
      kukariImage={String(BOARD_CONFIG[boardType]?.KUKARI_IMAGE?.[playerNumber as 1] ?? '')}
      glowImage={String(BOARD_CONFIG[boardType]?.GLOW_IMAGE?.[playerNumber as 1] ?? undefined)}
      height={getWidth(32)}
      width={getWidth(19)}
      currentCoordinates={calculateCoordinates(playerNumber, moveInfo.currentPosition)}
      nextCoordinates={calculateCoordinates(playerNumber, moveInfo.nextPosition)}
      isLongStep={checkIsLongStep(boardType, playerNumber, moveInfo.currentPosition)}
      moveKukari={moveKukari}
      opacity={opacity}
      stepScore={moveInfo.currentPosition - (initialPosition ?? 0)}
      playerNumber={playerNumber}
    />
    </div>
  );
}

export default MovingKukari;
